<h2 mat-dialog-title>{{ data.header }}</h2>
<mat-dialog-content>
    <ng-container *ngComponentOutlet="data.component; injector: data.data"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <esa-material-button mat-dialog-close label="Cancel" icon="cancel" type="clear" style="margin-right: 1rem"></esa-material-button>
    <esa-material-button [mat-dialog-close]="ngComponentOutlet" label="Save" icon="save" type="primary" [disabled]="!childFormIsValid"></esa-material-button>
</mat-dialog-actions>
